import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'gpe-arrows-v',
  templateUrl: './arrows-v.component.svg',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ArrowsVComponent { }
